import type { AdminSettingsSummary } from "./generated/openapi";
import { apiRequest, apiUrl } from "./http";

export const settingsApi = {
  get: (signal?: AbortSignal) =>
    apiRequest<AdminSettingsSummary>("/api/settings", { signal }),
  openApiUrl: () => apiUrl("/api/openapi.json"),
};

export type { AdminSettingsSummary } from "./generated/openapi";
